import { render, staticRenderFns } from "./TrainList.vue?vue&type=template&id=0317a96e&scoped=true"
import script from "./TrainList.vue?vue&type=script&lang=js"
export * from "./TrainList.vue?vue&type=script&lang=js"
import style0 from "./TrainList.vue?vue&type=style&index=0&id=0317a96e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0317a96e",
  null
  
)

export default component.exports